// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--2tsw_","heading":"styles-module--heading--2kal-","row":"styles-module--row--tJ4Rl","card":"styles-module--card--3mlzG"};